import React from "react";
import classnames from "classnames";
import { Col, Nav, NavItem } from "reactstrap";
import { NavLink } from "react-router-dom";

const NavTabInfoProfileInfo = ({
  activeTab,
  toggleTab,
  items,
  otherRender,
}) => {
  return (
    <Nav
      className="mt-2 mb-0  ms-3 card-header-tabs border-bottom-0 "
      role="tablist"
    >
      {items.map((item, index) => (
        <NavItem key={index} className="me-3">
          <NavLink
            className={classnames(
              {
                "active  p-2 text-primary": activeTab === item.tab,
                "fw-semibold": activeTab === item.tab,
              },
              {
                "border-bottom border-2 border-primary": activeTab === item.tab,
              },
              { "p-2 text-primary": activeTab !== item.tab }
            )}
            onClick={() => toggleTab(item.tab, item.value)}
            href="#"
          >
            {item.label}
          </NavLink>
        </NavItem>
      ))}
      {otherRender && (
        <Col className="mb-2" xs="12" sm="auto">
          <NavItem className="me-3 ">
            <NavLink>{otherRender()}</NavLink>
          </NavItem>
        </Col>
      )}
    </Nav>
  );
};

export default NavTabInfoProfileInfo;
